import useRouter from 'hooks/useRouter';
import ChargeModelListView from '../../components/ChargeModelListView';

function ChargeModelListScreen(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const chargeBrandId = router.query?.chargeBrandId;

  return <ChargeModelListView showFullUI={true} chargeBrandId={chargeBrandId} />;
}

export default ChargeModelListScreen;
